var _rect, _rect2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -903,
    y: -816,
    width: 1440,
    height: 1162,
    rx: 20,
    fill: "#FAFAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-903 -796C-903 -807.046 -894.046 -816 -883 -816H517C528.046 -816 537 -807.046 537 -796V326C537 337.046 528.046 346 517 346H-883C-894.046 346 -903 337.046 -903 326V-796Z",
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_46_2392)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -22,
    width: 480,
    height: 62,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17,
    y: -21,
    width: 478,
    height: 60,
    rx: 7,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0.0200043C4.49 0.0200043 0.0200043 4.49 0.0200043 10C0.0200043 15.51 4.49 19.98 10 19.98C15.51 19.98 19.98 15.51 19.98 10C19.98 4.49 15.51 0.0200043 10 0.0200043ZM10 17.98C5.6 17.98 2.02 14.4 2.02 10C2.02 5.6 5.6 2.02 10 2.02C14.4 2.02 17.98 5.6 17.98 10C17.98 14.4 14.4 17.98 10 17.98ZM10.75 3L6.25 11.5H9.39001V17L13.75 8.5H10.75V3Z",
    fill: "#1B59F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_46_2392",
    x: -38,
    y: -41,
    width: 520,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_46_2392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_46_2392",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearners);
export default __webpack_public_path__ + "static/media/learners.c29142e3a91fef4c9ce32f54bf26efe0.svg";
export { ForwardRef as ReactComponent };